import React, { useState } from 'react';
import {ChevronDown, Target, Users, BookOpen, Lightbulb, TrendingUp, FlaskConical, Rocket, Shield} from 'lucide-react';

const ObjectivesAccordion = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const objectives = [
        { icon: Users, title: 'Build Human Capital', desc: 'Build human capital in Artificial Intelligence through training, certifications, and workforce development.' },
        { icon: FlaskConical, title: 'Applied Research', desc: 'Conduct applied, Africa-relevant AI research using open science principles' },
        { icon: Rocket, title: 'Pilot Solutions', desc: 'Pilot and operationalize AI solutions with government, industry, civil society, and private sector partners.' },
        { icon: Shield, title: 'Policy & Ethics', desc: 'Strengthen policy, ethics, and data governance capacity for safe, inclusive, and accountable AI adoption.' },
        { icon: TrendingUp, title: 'Commercialization', desc: 'Support commercialization and local maintenance of AI systems to foster sustainable innovation ecosystems.' }
    ];

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <div className="bg-gradient-to-br from-gray-50 to-blue-50 py-20">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-12">
                    <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
                        Our Objectives
                    </h2>
                    <p className="text-gray-600 text-lg max-w-2xl mx-auto">
                        Comprehensive approach to building AI capacity across Africa
                    </p>
                </div>

                <div className="space-y-4">
                    {objectives.map((obj, idx) => {
                        const isActive = activeIndex === idx;
                        const Icon = obj.icon;

                        return (
                            <div
                                key={idx}
                                className={`bg-white rounded-2xl overflow-hidden transition-all duration-300 border-2 ${
                                    isActive
                                        ? 'border-blue-500 shadow-xl shadow-blue-100'
                                        : 'border-gray-200 hover:border-blue-300 shadow-sm hover:shadow-md'
                                }`}
                            >
                                <button
                                    onClick={() => toggleAccordion(idx)}
                                    className="w-full px-6 py-5 flex items-center justify-between text-left transition-colors duration-200 hover:bg-gray-50"
                                >
                                    <div className="flex items-center gap-4 flex-1">
                                        <div className={`rounded-xl w-12 h-12 flex items-center justify-center transition-all duration-300 ${
                                            isActive
                                                ? 'bg-transparent scale-110'
                                                : 'bg-transparent'
                                        }`}>
                                            <Icon className="w-6 h-6 text-blue-700" />
                                        </div>

                                        <div className="flex-1">
                                            <h4 className={`text-lg font-semibold transition-colors duration-200 ${
                                                isActive ? 'text-blue-600' : 'text-gray-900'
                                            }`}>
                                                {obj.title}
                                            </h4>
                                            {/* Show description preview on mobile when collapsed */}
                                            <p className={`text-sm text-gray-500 mt-1 md:hidden ${isActive ? 'hidden' : 'line-clamp-1'}`}>
                                                {obj.desc}
                                            </p>
                                        </div>
                                    </div>

                                    <ChevronDown
                                        className={`w-5 h-5 text-gray-400 transition-transform duration-300 flex-shrink-0 ml-4 ${
                                            isActive ? 'rotate-180 text-blue-500' : ''
                                        }`}
                                    />
                                </button>

                                <div
                                    className={`overflow-hidden transition-all duration-300 ${
                                        isActive ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                                    }`}
                                >
                                    <div className="px-6 pb-6 pt-2">
                                        <div className="pl-16">
                                            <div className="border-l-4 border-blue-200 pl-4 py-2">
                                                <p className="text-gray-700 leading-relaxed">
                                                    {obj.desc}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>

            </div>
        </div>
    );
};

export default ObjectivesAccordion;